import React from 'react'
import { Container, Card, Row, Tabs, Tab } from 'react-bootstrap';
import { WidgetsOutlined, ArrowBackIos } from '@material-ui/icons';
import EquinixForm from './EquinixForm';
import CyberpassForm from './CyberpassForm';
import { Link } from 'react-router-dom';
import CloudTelephonyForm from './CloudTelephonyForm';

export default function(){
  const providersCloudTelephony = [
    { id: 1, name: 'GoTo', eventKey: 'go_to' },
    { id: 5, name: 'Voice Manager', eventKey: 'voice_manager' }
  ]

  return (
    <Container fluid>
      <Row className="mt-2">
        <Link to="/master-agent/my-quotes/opportunities" className="link-back">
          <ArrowBackIos className="icon-title icon-back" />
          <h6 className="font-13 mt-3">Voltar</h6>
        </Link>
      </Row>
      <Row className="mt-1">
        <WidgetsOutlined className="icon-title col-auto p-0" />
        <h5 className="title-dashboard col-10 p-0">Pré Vendas - Enviar Oportunidade</h5>
      </Row>
      <Row>
        <Card.Body className="card-dashboard shadow bg-white rounded m-2 mb-5 col-12">
          <Tabs defaultActiveKey="form_equinix"  id="newOpportunity">                        
            <Tab eventKey="form_equinix" title="Equinix">
              <EquinixForm />
            </Tab>
            <Tab eventKey="form_cyberpass" title="Cyberpass">
              <CyberpassForm />
            </Tab>
            {providersCloudTelephony.map(provider => (
              <Tab eventKey={`form_cloud_telephony_${provider.eventKey}`} title={provider.name}>
                <CloudTelephonyForm 
                  key={provider.id}
                  provider={provider}
                />
              </Tab>
            ))}
          </Tabs>
        </Card.Body>
      </Row>
    </Container>
  )
}